import type { RootState } from "store/types";

// `application` (src/reducers/application.js) is a new slice unwound at the selector boundary
// for containers/BetHistory (PLAY-5216, Phase 1), following store/selectors/filters.ts's shape.
export function selectShowBetHistory(state: RootState): boolean | undefined {
  return state.application.get("showBetHistory");
}

// Added for containers/Update (PLAY-5216, Phase 3).
export function selectVersion(state: RootState): string | undefined {
  return state.application.get("version");
}

export function selectBuildno(state: RootState): string | undefined {
  return state.application.get("buildno");
}

// Added for containers/Navigation (PLAY-5216, Phase 3).
export function selectShowSearch(state: RootState): boolean | undefined {
  return state.application.get("showSearch");
}

// Added for containers/Application (PLAY-5216, Phase 4): fed into the `hasModalLaunched`
// OR-chain, same convention as game.ts's selectGameActionParams.
export function selectApplicationShowMenu(state: RootState): boolean | undefined {
  return state.application.get("showMenu");
}
